"use client"
import styles from "./css/timelineFilter.module.css"

const TimelineFilter = ({ activeStage, onStageChange, completedStages = [], patientSex, stageData = {}, visitedStages = [] }) => {
  // Timeline stages with numbers
  const stages = [
    { number: 1, label: "Chronic Condition" },
    { number: 2, label: "Family History" },
    { number: 3, label: "Allergies" },
    { number: 4, label: "Obstetrics" },
    { number: 5, label: "Consult" },
  ]

  const normalizedSex = String(patientSex ?? "").trim().toLowerCase()
  const isMale = normalizedSex === "male"
  const stagesToRender = isMale ? stages.filter(s => s.label !== "Obstetrics") : stages

  const isCompleted = (stageLabel) => {
    // Check if stage is in completedStages OR has data in stageData OR has been visited
    const isInCompletedStages = completedStages.includes(stageLabel)
    const hasStageData = stageData[stageLabel] !== null && stageData[stageLabel] !== undefined
    const hasBeenVisited = visitedStages.includes(stageLabel)
    return isInCompletedStages || hasStageData || hasBeenVisited
  }

  return (
    <div className={styles.timeline}>
      {stagesToRender.map((stage, index) => (
        <div key={stage.label} className={styles.timelineStep}>
          {/* Timeline Step */}
          <div className={styles.stepContainer}>
            <button
              className={`${styles.stepButton} ${
                activeStage === stage.label ? styles.active : ""
              } ${isCompleted(stage.label) ? styles.completed : ""}`}
              onClick={() => onStageChange(stage.label)}
            >
              {isCompleted(stage.label) ? "✓" : index + 1}
            </button>
            <span className={`${styles.stepLabel} ${activeStage === stage.label ? styles.activeLabel : ""}`}>
              {stage.label}
            </span>
          </div>

          {/* Connecting Line */}
          {index < stagesToRender.length - 1 && <div className={styles.connectingLine} />}
        </div>
      ))}
    </div>
  )
}

export default TimelineFilter
